import React, { useContext, useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { CheckEmailOtpError } from "iam-client/dist/client/password-reset/passwordReset";
import { OnEmailOtpRequiredApi } from "iam-client/dist/wrapper/resetPasswordFlow";
import { useMessageSource } from "react-message-source";
import TextInputField from "../../../pages/shared/components/formik/text-input";
import ApplicationPageContent from "../../../ui/layout/page/content/application";
import ContentFooter from "../../../ui/layout/page/content/footer";
import NavigationBar from "../../../ui/layout/page/content/footer/navigation-bar";
import FormContainer from "../../../ui/layout/page/forms-container/form-base-container";
import InputContainer from "../../../ui/layout/page/forms-container/form-item-container/input-container";
import TypographyContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import TypographyItemContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import CustomTypography from "../../../ui/widgets/typography";
import { displayErrorInField } from "../../../util/formik";
import usePasswordResetOtpFormValidationScheme from "./validator";
import { LanguageContext } from "../../../context/languageContext";

import logging from "../../../util/logging";
import { useNavigate } from "react-router-dom";
const log = logging("otp form page");

type FormData = {
  emailOtp: string;
};

export default function PasswordResetOtpForm({
  email,
  onNext,
}: {
  email: string;
  onNext: OnEmailOtpRequiredApi;
}): React.JSX.Element {
  const { getMessage, getMessageWithNamedParams } = useMessageSource();
  const { language } = useContext(LanguageContext);
  const navigate = useNavigate();
  const formErrors: CheckEmailOtpError[] = onNext && onNext.errors;
  const [formikActions, setFormikActions] = useState<FormikHelpers<FormData>>();

  if (formErrors) {
    if (formikActions) {
      displayErrorInField(
        formikActions,
        "emailOtp",
        getMessage("PasswordReset.ErrorOnAirlock"),
      );
    }
  }

  const next = (values: FormData, action: FormikHelpers<FormData>) => {
    if (onNext) {
      onNext.proceed({ otp: values.emailOtp });
    } else {
      log.error(
        "New password flow: Cannot proceed in OTP form, due to a missing callback",
      );
    }
    setFormikActions(action);
  };

  const previous = () => {
    navigate("/login");
  };

  return (
    <ApplicationPageContent>
      <TypographyContainer>
        <TypographyItemContainer>
          <CustomTypography variant="h3">
            {getMessage("PasswordReset.confirmCode")}
          </CustomTypography>
          <CustomTypography variant="body1">
            {getMessageWithNamedParams(
              "PasswordReset.pleaseConfirmTheOtpCode",
              {
                email,
              },
            )}
          </CustomTypography>
        </TypographyItemContainer>
      </TypographyContainer>
      <Formik
        key={language}
        initialValues={{ emailOtp: "" }}
        validationSchema={usePasswordResetOtpFormValidationScheme()}
        onSubmit={next}
      >
        {({ handleSubmit }) => {
          return (
            <Form>
              <FormContainer>
                <InputContainer>
                  <TextInputField
                    forceReRender
                    name="emailOtp"
                    label={getMessage("EmailAddressVerification.code")}
                  />
                </InputContainer>
              </FormContainer>
              <ContentFooter>
                <NavigationBar
                  backButtonText={getMessage("Onboarding.cancel")}
                  nextButtonText={getMessage("Onboarding.continue")}
                  onBack={previous}
                  onNext={handleSubmit}
                />
              </ContentFooter>
            </Form>
          );
        }}
      </Formik>
    </ApplicationPageContent>
  );
}
